var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMapPin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666668 8.33333C0.666668 3.75 4.41667 0 9 0C13.5833 0 17.3333 3.75 17.3333 8.33333C17.3333 14.5 9.75 19.6667 9.5 19.8333C9.33333 19.9167 9.16667 20 9 20C8.83333 20 8.66667 19.9167 8.5 19.8333C8.25 19.6667 0.666668 14.5 0.666668 8.33333ZM2.33333 8.33333C2.33333 12.8333 7.41667 17 9 18.1667C10.5833 17 15.6667 12.8333 15.6667 8.33333C15.6667 4.66667 12.6667 1.66667 9 1.66667C5.33333 1.66667 2.33333 4.66667 2.33333 8.33333ZM9 5C7.16667 5 5.66667 6.5 5.66667 8.33333C5.66667 10.1667 7.16667 11.6667 9 11.6667C10.8333 11.6667 12.3333 10.1667 12.3333 8.33333C12.3333 6.5 10.8333 5 9 5ZM7.33333 8.33333C7.33333 9.25 8.08333 10 9 10C9.91667 10 10.6667 9.25 10.6667 8.33333C10.6667 7.41667 9.91667 6.66667 9 6.66667C8.08333 6.66667 7.33333 7.41667 7.33333 8.33333Z",
    fill: "#828282"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPin);
export default __webpack_public_path__ + "static/media/mapPin.bff9ccef3474a60ce730c1570076e96b.svg";
export { ForwardRef as ReactComponent };